import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable, throwError, pipe } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { AuthenticationService } from '../../core/services/authentication.service';
import { GenericService } from '@app/core/services/generic.service';

import { Documento, Loading } from '@app/shared/models';
import { AddHttpParams } from '@app/core/services/add-http-params';

@Injectable({
  providedIn: 'root'
})
export class DocumentosService extends GenericService<any> {

  constructor(http: HttpClient, private auth: AuthenticationService) {
    super('censo/autoAtendimento', http);
  };

  get idAutoAtendimento(): number {
    return this.auth.currentUserValue.idAutoAtendimento;
  }

  get apiBase(): string {
    return `${this.api}/${this.idAutoAtendimento}/documentos`;
  }

  get(loading?: Loading): Observable<Documento[]>{
    this.startLoading(loading);
    return this.getHttpClient().get<Documento[]>(`${ this.apiBase }`)
      .pipe(this.configMapAndLoading(loading), this.result());
  }

  enviarDocumento(
    arquivo: any,
    documentoId: number,
    filter?: any,
    loading?: Loading
  ): Observable<any> {
    const params = new AddHttpParams(filter).createParams();
    this.startLoading(loading);
    let URL = `${ this.apiBase }/documentacao/${documentoId}`;
    return this.getHttpClient()
      .post(URL, arquivo, { headers: new HttpHeaders({ Accept: '*/*' }), params})
      .pipe(this.configMapAndLoading(loading), this.result());
  }

  enviarDocumentoIdentificacao(arquivo: any, tipoIdentificacao: string, loading?: Loading): Observable<any> {
    this.startLoading(loading);
    return this.getHttpClient()
      .post(`${ this.apiBase }/identificacao/${tipoIdentificacao}`, arquivo, { headers: new HttpHeaders({ Accept: '*/*' })})
      .pipe(this.configMapAndLoading(loading), this.result());
  }

  removerDocumento(
    idArquivoEnviado: number,
    loading?: Loading
  ): Observable<any> {
    this.startLoading(loading);
    let URL = `${ this.apiBase }/documentacao/${idArquivoEnviado}`;

    return this.getHttpClient()
      .delete(URL, { headers: new HttpHeaders({ Accept: '*/*' })})
      .pipe(this.configMapAndLoading(loading), this.result());
  }

  visualizarDocumento(
    idArquivoEnviado: number,
    loading?: Loading
  ): Observable<any> {
    this.startLoading(loading);
    let URL = `${ this.apiBase }/documentacao/${idArquivoEnviado}`;

    return this.getHttpClient()
      .get(URL, { headers: new HttpHeaders({ Accept: '*/*' }), responseType: 'blob'})
      .pipe(this.configMapAndLoading(loading), this.result());
  }

  result(): any{
    return pipe(
      map((res: any) => res),
      catchError((err: any) => throwError({ message: err })));
   }
}
